/**
 * Utilities for working with 360° image sequences
 */

const format360FrameIndex = (index: number) =>
  String(index + 1).padStart(2, "0");

type Build360UrlOptions = {
  size?: "2000x2000" | "960x960" | "750x750" | "300x300";
  extension?: "avif" | "jpg";
};

/** Build a 360 image URL following our URL structure */
export const build360ImageUrl = (
  baseUrl: string,
  frameIndex: number,
  { size = "2000x2000", extension = "avif" }: Build360UrlOptions = {},
): string => {
  if (!baseUrl) return "";

  const index = format360FrameIndex(frameIndex);

  return `${baseUrl}/${size}/360_shirt_${index}.${extension}`;
};
